const Marquee = ({ items, dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`marquee-band relative overflow-hidden border-y py-5 ${
      dark ? "border-emerald-100/10 bg-night" : "border-emerald-200 bg-emerald-50"
    }`}
  >
    <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-12" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span
              key={i}
              className={`flex items-center gap-12 font-mono text-xs font-medium uppercase tracking-[0.3em] ${
                dark ? "text-emerald-200/70" : "text-emerald-800/70"
              }`}
            >
              {item}
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-amber-500" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
